import React from "react";
import '../styles/Enlaces.css';
/*Iconos*/
import Tiktok_icon from '../imagenes/icons/tiktok.png';
import Facebook_icon from '../imagenes/icons/facebook.png';
import Youtube_icon from '../imagenes/icons/youtube.png';
import Xtwitter_icon from '../imagenes/icons/x.png';
import Instagram_icon from '../imagenes/icons/instagram.png';
import Telf_icon from '../imagenes/icons/telf.png';
import Portal_Trans from '../imagenes/icons/portalTransparente.png';


function Enlaces(){
  return(
    <section className='section'>
      <div className='telf'>
        <img src={Telf_icon} className='icon'></img>
        <p>Serenazgo: (+51) 913 598 382</p>
      </div>
      <div className='icons'>
        <a href='https://web.facebook.com/munichumbivilcas' target='_blank'>
          <img src={Facebook_icon} className='icon'></img>
        </a>
        <a href='https://www.tiktok.com/@munichumbivilcas?is_from_webapp=1&sender_device=pc' target='_blank'>
          <img src={Tiktok_icon} className='icon'></img>
        </a>
        <a href='https://www.instagram.com/chumbivilcasm/?fbclid=IwY2xjawKGde9leHRuA2FlbQIxMABicmlkETF4M3ZZd2JHbmVnajg0bTBuAR5wed0e_FAsJgKmC2fEuzskZ24xftnAaWf_tBD6bwWiWK6LwEqIFIB4yBn83Q_aem_p0I8lAu8TmXXe6_9vdCWWg#' target='_blank'>
          <img src={Instagram_icon} className='icon'></img>
        </a>
        <a href='https://www.youtube.com/channel/UCDyUske5v7o7TrXe-9Hvvrw' target='_blank'>
          <img src={Youtube_icon} className='icon'></img>
        </a>
        <a href='https://twitter.com/ChumbivilcasM' target='_blank'>
          <img src={Xtwitter_icon} className='icon'></img>
        </a>
        <a href='http://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=11810&id_tema=1&ver=D#.XHVxBKC22M8' target='_blank'> 
          <img src={Portal_Trans} className='portal'></img>
        </a>
      </div>
    </section>
  );
};
export default Enlaces;